import { Navigate, type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "dashboard",
  element: <Navigate to="/my-situation" replace />,
  children: [
    {
      path: "*",
      element: <Navigate to="/my-situation" replace />,
    },
  ],
}

export default routes
